module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', [_c('website', {
    ref: "website"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-width"
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "grid__item medium-up--four-fifths large--three-quarters main-col right"
  }, [_c('div', {
    staticClass: "productList"
  }, [_c('DataView', {
    staticClass: "grid grid--uniform grid-products grid--view-items",
    staticStyle: {
      "width": "80%",
      "margin-top": "3%"
    },
    attrs: {
      "value": _vm.displayItemList,
      "paginator": true,
      "rows": 28,
      "layout": _vm.layout
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', {
          staticClass: "p-grid p-nogutter"
        }, [_c('InputText', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "placeholder": "Please enter keyword"
          },
          on: {
            "input": _vm.searchItemWithUserInput
          },
          model: {
            value: (_vm.searchTerm),
            callback: function($$v) {
              _vm.searchTerm = $$v
            },
            expression: "searchTerm"
          }
        })], 1)]
      },
      proxy: true
    }, {
      key: "grid",
      fn: function(slotProps) {
        return [_c('div', {
          staticClass: "p-col-12 p-md-3",
          staticStyle: {
            "border-bottom": "0px solid #c8c8c8"
          }
        }, [_c('div', {
          staticClass: "productList"
        }, [_c('div', {
          staticClass: "grid__item small--one-half medium--one-third large-up--one-quarter"
        }, [_c('div', {
          staticClass: "grid-view-item style1 wow fadeIn"
        }, [_c('div', {
          staticClass: "grid-view_image"
        }, [_c('a', {
          attrs: {
            "href": ""
          }
        }, [_c('img', {
          staticStyle: {
            "height": "310px",
            "width": "95%"
          },
          attrs: {
            "src": slotProps.data.singleImageUrl,
            "alt": slotProps.data.name
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "grid-view-item__title"
        }, [_vm._v(_vm._s(slotProps.data.name))]), _vm._v(" "), _c('span', {
          staticClass: "product-price__price"
        }, [_vm._v("Rs." + _vm._s(slotProps.data.salesRate))]), _vm._v(" "), _c('div', {
          staticClass: "product-description"
        }, [_vm._v(_vm._s(slotProps.data.description))])])])])])])]
      }
    }])
  })], 1)])])]), _vm._v(" "), _c('Dialog', {
    style: ({
      width: '50vw'
    }),
    attrs: {
      "header": "Product Details",
      "modal": true,
      "visible": _vm.showPosDialog,
      "closable": false,
      "contentStyle": {
        'overflow': 'visible'
      }
    },
    on: {
      "update:visible": function($event) {
        _vm.showPosDialog = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('Button', {
          staticClass: "p-button-raised p-button-rounded",
          attrs: {
            "label": "Back"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.cancel.apply(null, arguments)
            }
          }
        })]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v(" Name: "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(this.itemName))])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "shortName"
    }
  }, [_vm._v("Rate ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(this.sellingPrice))])])])]), _vm._v(" "), _c('footerWebsite', {
    ref: "footerWebsite"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39c44ad5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/ecommerce/shop.vue
// module id = 2155
// module chunks = 0